import React from 'react';
import FieldRenderer from './fields/FieldRenderer';

function ConditionalFields({ fields, values, onChange, errors, stores, readOnly = false }) {
  // Filter fields based on dependencies
  const getVisibleFields = () => {
    return fields.filter(field => {
      // If no dependency, always show
      if (!field.depends_on_field) {
        return true;
      }

      // Check if dependency is met
      const dependentValue = values[field.depends_on_field];
      const expectedValue = field.depends_on_value;

      // Handle array of expected values
      if (Array.isArray(expectedValue)) {
        return expectedValue.includes(dependentValue);
      }

      // Handle single expected value
      return dependentValue === expectedValue;
    });
  };

  const visibleFields = getVisibleFields();

  if (visibleFields.length === 0) {
    return null;
  }

  return (
    <div className="conditional-fields-container">
      <h3 className="conditional-fields-title">Additional Information</h3>
      <div className="conditional-fields-grid">
        {visibleFields.map(field => (
          <FieldRenderer
            key={field.field_code}
            field={field}
            value={values[field.field_code]}
            onChange={onChange}
            error={errors[field.field_code]}
            stores={stores}
            readOnly={readOnly}
          />
        ))}
      </div>
    </div>
  );
}

export default ConditionalFields;